import { render } from "./Footer.vue?vue&type=template&id=2f13ca6f&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=2f13ca6f&lang=scss&scoped=true"

import exportComponent from "C:\\bonch\\okimi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f13ca6f"]])

export default __exports__